const _ = require("lodash");

// Returns data that is sent to the backend in API calls

const computeRegistrationUser = function(userModel) {
	return {
		username: userModel.username,
		avatarData: userModel.avatar,
		password: userModel.password,
		email: userModel.email,
	};
};

const msToNearestTenthSeconds = function(timeInMs) {
	return _.round(timeInMs / 1000, 1);
};

const msToNearestSecond = function(timeInMs) {
	return _.round(timeInMs / 1000);
};

const computeUser = function(userModel) {
	const cloneUser = _.omit(userModel, ["avatar", "settings", "miscellaneous"]);
	if (userModel.avatar) {
		cloneUser.avatarData = _.omit(userModel.avatar, [
			"avatarImageData",
			"undoList",
			"redoList",
		]);
	}
	if (userModel.settings) {
		cloneUser.settingsData = userModel.settings;
	}
	if (userModel.miscellaneous) {
		cloneUser.miscData = userModel.miscellaneous;
	}
	return cloneUser;
};

module.exports = {
	computeRegistrationUser,
	msToNearestTenthSeconds,
	msToNearestSecond,
	computeUser,
};
